
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/de/en/giveback",
      function () {
        return require("private-next-pages/de/en/giveback.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/de/en/giveback"])
      });
    }
  